import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base';
import {  BatchInjectLocationInJobRequest } from '../../domain';
import { JobsRepository } from '../../repositories';


@Injectable({ providedIn: 'root' })
export class BatchInjectLocationJobUsecase implements UseCase<BatchInjectLocationInJobRequest,boolean> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(params: BatchInjectLocationInJobRequest): Observable<boolean> {
    return this.jobRepository.batchInjectLocationInJobs(params);
  }

}
